import React, { Component } from "react";
import { getLastElementOr, showlog, beautify, isNotEmptyArray, normalizeSearchText } from "../../utils";
import 'mapbox-gl/dist/mapbox-gl.css';
import { debounceTime, distinct, fromEvent, map } from 'rxjs';
import { DATE_FORMAT_IT } from "../../conf";
import {
	getLast28DaysOrdersMagnitude,
	getLastVersion,
	getTodayOrdersMagnitude, getYesterdayOrdersMagnitude,
	searchOrders
} from "./orders-v2";
import '../../style/order.css';
import './orders-v2.css';
import { WaitingOverPageComponent } from "../../components/WaitingOverComponent/waiting-over-component";
import moment from 'moment';
import '../../style/validity-setting-pannel-style.css';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { AlertPanel } from "../../components/alert/alert-panel";
import { ArticleComponent } from "./components/ArticleComponent";
import { OrderComponent } from "./components/OrderComponent";
import { orderFieldMap, getOrderStatusMeta } from "./static";
import { prepareOrderCurl } from "../../business-logic/order";
import { NewOrderDataType } from "../../models/device";
import { getCompanies } from "../companies-page/companies-service";

export class OrdersPageV2 extends Component<any, any> {


	state = {
		orders: [],
		inWaiting: false,
		activeTab: null,
		search: {
			search: "",
			from: moment().add(-2, "days"),
			to: moment(),
			page: 1,
			company: "",
			potential: false
		},
		rawOrderPopup: null,
		articlesImages: [],
		magnitude: 0,
		magnitudeToday: 0,
		magnitudeYesterday: 0,
		magnitudeLast28Days: 0,
		companyImagesLoaded: [],
		// currentPage: 1
		lastVersion: null,
		openPannels: [],
		errorPannel: undefined,
		openArticlePannels: [],
		companies: [] as string[],
		selectedCompany: "",
		companySearchInput: "",
		isCompanyDropdownOpen: false,
		loadingMagnitudes: false,
		highlightedCompanyIndex: -1,
		selectedVersionFrom: "",
		selectedVersionTo: "",
		loadingMore: false,
		hasMore: true,
		sortField: null as string | null,
		sortDirection: 'asc' as 'asc' | 'desc',
		selectedPlatform: [] as string[],
		isFilterPanelOpen: false,
	}

	constructor(props) {
		super(props);


		this.setSearch = this.setSearch.bind(this);

	}

	getOrderMagnitudes = async () => {
		try {
			showlog('getOrderMagnitudes()');
			this.setState({ loadingMagnitudes: true });

			const search = this.state.search.search;
			const company = this.state.selectedCompany;
			const versionFrom = this.state.selectedVersionFrom;
			const versionTo = this.state.selectedVersionTo;
			const potential = this.state.search.potential;
			const platform = this.state.selectedPlatform.join(',');

			const mag = await getTodayOrdersMagnitude(company, search, versionFrom, versionTo, potential, platform)
			const mag2 = await getYesterdayOrdersMagnitude(company, search, versionFrom, versionTo, potential, platform)
			const mag3 = await getLast28DaysOrdersMagnitude(company, search, versionFrom, versionTo, potential, platform)

			this.setState({
				...this.state,
				magnitudeToday: mag?.data || 0,
				magnitudeYesterday: mag2?.data || 0,
				magnitudeLast28Days: mag3?.data || 0,
				loadingMagnitudes: false
			})
		} catch (e) {
			showlog("error in getOrderMagnitudes()", e);
			this.setState({ loadingMagnitudes: false });
		}

	}

	setSearch = () => {

		return (
			new Promise<any>((onEnd, onFail) => {
				showlog("Alla ricerca", this.state.search.search);

				const searchParams = {
					...this.state.search,
					company: this.state.selectedCompany,
					versionFrom: this.state.selectedVersionFrom,
					versionTo: this.state.selectedVersionTo,
					potential: this.state.search.potential,
					platform: this.state.selectedPlatform.join(','),
				};

				Promise.resolve()
					.then(() => {
						// if (this.state.magnitude === 0) {
						// 	return (
						// 		searchMagnitudeOrders(this.state.search)
						// 			.then(magnitude => {
						// 				showlog("order magnitude: ", magnitude)
						// 				return magnitude
						// 			})
						// 			.catch(e => {
						// 				showlog("errore alla magnitude");
						// 				showlog(e);
						// 				onFail(e);
						// 			})
						// 	)
						// } else return this.state.magnitude
						return 0
					})
					.then(magnitude => {
						searchOrders(searchParams)
							.then(result => {
								showlog("ritorno dalla ricerca");
								showlog(result);

								showlog('lista ritorno filtrata', result.filter(data => (!!data.payload && !!data.payload.deliveryAddress)))

								this.setState({
									...this.state,
									orders: result || [],
									magnitude: magnitude,
									hasMore: (result || []).length === 256,
									search: {
										...this.state.search,
										company: this.state.selectedCompany,
										page: 1
									},
									// offset: 0,
									inWaiting: false
								})



							})
							.catch(e => {
								showlog("errore");
								showlog(e);
								onFail(e);
							})
					})
					.then(() => {
						this.getOrderMagnitudes()
					})


					;
			})
		);


	}

	loadMoreOrders = () => {
		if (this.state.loadingMore || !this.state.hasMore) return;

		const nextPage = this.state.search.page + 1;
		this.setState({ loadingMore: true }, () => {
			const searchParams = {
				...this.state.search,
				page: nextPage,
				company: this.state.selectedCompany,
				versionFrom: this.state.selectedVersionFrom,
				versionTo: this.state.selectedVersionTo,
				potential: this.state.search.potential,
				platform: this.state.selectedPlatform.join(','),
			};

			searchOrders(searchParams)
				.then(result => {
					this.setState({
						...this.state,
						orders: [...(this.state.orders as any[]), ...(result || [])],
						loadingMore: false,
						hasMore: (result || []).length === 256,
						search: {
							...this.state.search,
							page: nextPage
						}
					});
				})
				.catch(e => {
					showlog("error in loadMoreOrders()", e);
					this.setState({ loadingMore: false });
				});
		});
	}

	onFromDatePick = (newDateSelected: Date) => {
		showlog('date selected', newDateSelected, (new Date(newDateSelected)).getTime());

		// let clonedRange = JSON.parse(JSON.stringify(range));
		// clonedRange[0] = (new Date(newDateSelected)).getTime();

		showlog('range in search', this.state.search);


		const selectedDate = moment(new Date(newDateSelected))
		// controllo range
		if (selectedDate < this.state.search.to) {
			showlog('range OK');

			this.setState({
				...this.state,
				search: {
					...this.state.search,
					from: selectedDate
				},
				inWaiting: true,
			},
				() => {
					this.setSearch();
				}
			);
		} else {

			// showlog('range non valido');
			// debugger;

			this.setState({
				...this.state,
				errorPannel: (
					<div className={'validity-date-alert-panel'}>
						<h4 className={''}>Attenzione</h4>
						<span>Hai selezionato una data di inizio validità precedente a quella di inizio</span>
					</div>
				)
			})
		}
	}

	onToDatePick = (newDateSelected: Date) => {
		showlog('date selected', newDateSelected, (new Date(newDateSelected)).getTime());

		// let clonedRange = JSON.parse(JSON.stringify(range));
		// clonedRange[0] = (new Date(newDateSelected)).getTime();

		showlog('range in search', this.state.search);

		const selectedDate = moment(new Date(newDateSelected))
		// controllo range
		if (this.state.search.from < selectedDate) {
			showlog('range OK');

			this.setState({
				...this.state,
				search: {
					...this.state.search,
					to: selectedDate
				},
				inWaiting: true,
			},
				() => {
					this.setSearch();
				}
			);
		} else {

			this.setState({
				...this.state,
				errorPannel: (
					<div className={'validity-date-alert-panel'}>
						<h4 className={''}>Attenzione</h4>
						<span>Hai selezionato una data di fine validita precedente a quella di inizio</span>
					</div>
				)
			})

		}
	}

	setTodayFilter = () => {
		this.setState({
			...this.state,
			search: {
				...this.state.search,
				from: moment().startOf('day'),
				to: moment().endOf('day')
			},
			inWaiting: true
		}, () => {
			this.setSearch();
		});
	}

	setYesterdayFilter = () => {
		this.setState({
			...this.state,
			search: {
				...this.state.search,
				from: moment().subtract(1, 'days').startOf('day'),
				to: moment().subtract(1, 'days').endOf('day')
			},
			inWaiting: true
		}, () => {
			this.setSearch();
		});
	}

	setLast7DaysFilter = () => {
		this.setState({
			...this.state,
			search: {
				...this.state.search,
				from: moment().subtract(7, 'days').startOf('day'),
				to: moment().endOf('day')
			},
			inWaiting: true
		}, () => {
			this.setSearch();
		});
	}

	setLast30DaysFilter = () => {
		this.setState({
			...this.state,
			search: {
				...this.state.search,
				from: moment().subtract(30, 'days').startOf('day'),
				to: moment().endOf('day')
			},
			inWaiting: true
		}, () => {
			this.setSearch();
		});
	}

	toggleCompanyDropdown = () => {
		this.setState({
			isCompanyDropdownOpen: !this.state.isCompanyDropdownOpen,
			companySearchInput: "",
			highlightedCompanyIndex: -1
		});
	}

	handleCompanyKeyDown = (e: React.KeyboardEvent, filteredCompanies: string[]) => {
		const { highlightedCompanyIndex } = this.state;

		if (e.key === 'ArrowDown') {
			e.preventDefault();
			const nextIndex = highlightedCompanyIndex < filteredCompanies.length - 1 ? highlightedCompanyIndex + 1 : 0;
			this.setState({ highlightedCompanyIndex: nextIndex }, () => {
				this.scrollHighlightedIntoView(nextIndex);
			});
		} else if (e.key === 'ArrowUp') {
			e.preventDefault();
			const prevIndex = highlightedCompanyIndex > 0 ? highlightedCompanyIndex - 1 : filteredCompanies.length - 1;
			this.setState({ highlightedCompanyIndex: prevIndex }, () => {
				this.scrollHighlightedIntoView(prevIndex);
			});
		} else if (e.key === 'Enter') {
			e.preventDefault();
			if (highlightedCompanyIndex >= 0 && highlightedCompanyIndex < filteredCompanies.length) {
				this.selectCompany(filteredCompanies[highlightedCompanyIndex]);
			}
		} else if (e.key === 'Escape') {
			this.setState({ isCompanyDropdownOpen: false });
		}
	}

	scrollHighlightedIntoView = (index: number) => {
		const element = document.getElementById(`company-option-${index}`);
		if (element) {
			element.scrollIntoView({ block: 'nearest' });
		}
	}

	selectCompany = (company: string) => {
		this.setState({
			...this.state,
			selectedCompany: company,
			isCompanyDropdownOpen: false,
			inWaiting: true
		}, () => {
			this.setSearch();
		});
	}

	render() {


		showlog("render ORDER-PAGE", this.state, this.props);

		const sortedOrders = !this.state.sortField
			? [...(this.state.orders as any[])]
			: [...(this.state.orders as any[])].sort((a, b) => {
				const aVal = a[this.state.sortField!] ?? '';
				const bVal = b[this.state.sortField!] ?? '';
				if (aVal < bVal) return this.state.sortDirection === 'asc' ? -1 : 1;
				if (aVal > bVal) return this.state.sortDirection === 'asc' ? 1 : -1;
				return 0;
			});

		const normalizedCompanySearchInput = normalizeSearchText(this.state.companySearchInput);
		const filteredCompanies = [
			"", // Represents "Tutte le aziende"
			...this.state.companies
				.filter(c => normalizeSearchText(c).includes(normalizedCompanySearchInput))
		];

		return (
			<React.Fragment>

				<div className={"logs-page-header"}>

				</div>


				{/* ── Main header bar ── */}
				<div className={"orders-header-container"}>
					<div className={"orders-title-section"}>
						<div className={"orders-title"}>
							<h1>Ordini</h1>
						</div>
						<div className={"search-bar-container"}>
							<div className={"search-icon"}>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<circle cx="11" cy="11" r="8"></circle>
									<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
								</svg>
							</div>
							<input
								type={"text"}
								id={"searchText"}
								placeholder={"Cerca..."}
								defaultValue={this.state.search.search}
							/>
						</div>
					</div>

					<div className={"date-filters-section"}>
						<div className={"section-title"}>Range Temporale</div>
						<div className={"date-inputs-row"}>
							<div className={"date-filter-item"}>
								<label>Dal</label>
								<DatePicker
									selected={new Date(moment(this.state.search.from).toISOString())}
									onChange={this.onFromDatePick}
									dateFormat={DATE_FORMAT_IT.toLowerCase()}
									customInput={<div className="custom-datepicker-input">{moment(this.state.search.from).format(DATE_FORMAT_IT)}</div>}
									showYearDropdown
									dateFormatCalendar="MMMM"
									yearDropdownItemNumber={75}
									scrollableYearDropdown
									dropdownMode="select"
								/>
							</div>
							<div className={"date-filter-item"}>
								<label>Al</label>
								<DatePicker
									selected={new Date(moment(this.state.search.to).toISOString())}
									onChange={this.onToDatePick}
									dateFormat={DATE_FORMAT_IT.toLowerCase()}
									customInput={<div className="custom-datepicker-input">{moment(this.state.search.to).format(DATE_FORMAT_IT)}</div>}
									showYearDropdown
									dateFormatCalendar="MMMM"
									yearDropdownItemNumber={75}
									scrollableYearDropdown
									dropdownMode="select"
								/>
							</div>
						</div>
						<div className={"quick-filters"}>
							<button
								className={`quick-filter-btn ${moment(this.state.search.from).isSame(moment(), 'day') && moment(this.state.search.to).isSame(moment(), 'day') ? 'active' : ''}`}
								onClick={this.setTodayFilter}
							>
								Oggi
							</button>
							<button
								className={`quick-filter-btn ${moment(this.state.search.from).isSame(moment().subtract(1, 'days'), 'day') && moment(this.state.search.to).isSame(moment().subtract(1, 'days'), 'day') ? 'active' : ''}`}
								onClick={this.setYesterdayFilter}
							>
								Ieri
							</button>
							<button
								className={`quick-filter-btn ${moment(this.state.search.from).isSame(moment().subtract(7, 'days'), 'day') && moment(this.state.search.to).isSame(moment(), 'day') ? 'active' : ''}`}
								onClick={this.setLast7DaysFilter}
							>
								Ultimi 7 gg
							</button>
							<button
								className={`quick-filter-btn ${moment(this.state.search.from).isSame(moment().subtract(30, 'days'), 'day') && moment(this.state.search.to).isSame(moment(), 'day') ? 'active' : ''}`}
								onClick={this.setLast30DaysFilter}
							>
								Ultimi 30 gg
							</button>
							<span className={"quick-filters-divider"} />
							{(() => {
								const activeCount = [
									!!this.state.selectedCompany,
									!!this.state.selectedVersionFrom || !!this.state.selectedVersionTo,
									this.state.selectedPlatform.length > 0,
									this.state.search.potential,
								].filter(Boolean).length;
								return (
									<button
										className={`filter-toggle-btn${this.state.isFilterPanelOpen ? ' open' : ''}${activeCount > 0 ? ' has-active' : ''}`}
										onClick={() => this.setState({ isFilterPanelOpen: !this.state.isFilterPanelOpen })}
									>
										<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<line x1="4" y1="6" x2="20" y2="6"></line>
											<line x1="8" y1="12" x2="16" y2="12"></line>
											<line x1="11" y1="18" x2="13" y2="18"></line>
										</svg>
										Filtri
										{activeCount > 0 && <span className="filter-count-badge">{activeCount}</span>}
									</button>
								);
							})()}
						</div>
					</div>

					<div className={"stats-section"}>
						<div className={"stat-block"}>
							<div className={`stat-value ${this.state.loadingMagnitudes ? 'loading' : ''}`}>
								{this.state.loadingMagnitudes ? '...' : this.state.magnitudeToday}
							</div>
							<div className={"stat-label"}>Ordini oggi</div>
							<div className={"stat-footer"}>
								<div className={"trend-dot"}></div>
								<span>{moment().format('DD/MM/YYYY')}</span>
							</div>
						</div>
						<div className={"stat-block"}>
							<div className={`stat-value ${this.state.loadingMagnitudes ? 'loading' : ''}`}>
								{this.state.loadingMagnitudes ? '...' : this.state.magnitudeYesterday}
							</div>
							<div className={"stat-label"}>Ieri</div>
							<div className={"stat-footer"}>
								<div className={"trend-dot"}></div>
								<span>{moment().add(-1, 'days').format('DD/MM/YYYY')}</span>
							</div>
						</div>
						<div className={"stat-block"}>
							<div className={`stat-value ${this.state.loadingMagnitudes ? 'loading' : ''}`}>
								{this.state.loadingMagnitudes ? '...' : this.state.magnitudeLast28Days}
							</div>
							<div className={"stat-label"}>Ultimi 28gg</div>
							<div className={"stat-footer"}>
								<div className={"trend-dot"}></div>
								<span>Trend attivo</span>
							</div>
						</div>
					</div>
				</div>

				{/* ── Advanced filter panel ── */}
				{this.state.isFilterPanelOpen && (
					<div className={"filter-panel"}>
						<div className={"filter-panel-grid"}>

							<div className={"filter-panel-item"}>
								<div className={"filter-panel-label"}>Azienda</div>
								<div className={`company-selector-container ${this.state.isCompanyDropdownOpen ? 'open' : ''}`}>
									<div
										className={`custom-select-trigger ${this.state.selectedCompany ? 'selected' : ''} ${this.state.isCompanyDropdownOpen ? 'active' : ''}`}
										onClick={this.toggleCompanyDropdown}
									>
										{this.state.selectedCompany || "Tutte le aziende"}
										<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<polyline points="6 9 12 15 18 9"></polyline>
										</svg>
									</div>
									{this.state.isCompanyDropdownOpen && (
										<div className="company-dropdown-menu">
											<div className="dropdown-search-container">
												<input
													type="text"
													className="company-search-input"
													placeholder="Cerca azienda..."
													value={this.state.companySearchInput}
													onChange={(e) => this.setState({ companySearchInput: e.target.value, highlightedCompanyIndex: -1 })}
													onKeyDown={(e) => {
														const { highlightedCompanyIndex } = this.state;
														if (e.key === 'ArrowDown') {
															e.preventDefault();
															const next = highlightedCompanyIndex < filteredCompanies.length - 1 ? highlightedCompanyIndex + 1 : 0;
															this.setState({ highlightedCompanyIndex: next }, () => this.scrollHighlightedIntoView(next));
														} else if (e.key === 'ArrowUp') {
															e.preventDefault();
															const prev = highlightedCompanyIndex > 0 ? highlightedCompanyIndex - 1 : filteredCompanies.length - 1;
															this.setState({ highlightedCompanyIndex: prev }, () => this.scrollHighlightedIntoView(prev));
														} else if (e.key === 'Enter') {
															e.preventDefault();
															if (highlightedCompanyIndex >= 0 && highlightedCompanyIndex < filteredCompanies.length) {
																this.setState({ selectedCompany: filteredCompanies[highlightedCompanyIndex], isCompanyDropdownOpen: false, companySearchInput: "" });
															}
														} else if (e.key === 'Escape') {
															this.setState({ isCompanyDropdownOpen: false });
														}
													}}
													autoFocus
												/>
											</div>
											<div className="company-options-list">
												<div
													id="company-option-0"
													className={`company-option ${this.state.selectedCompany === "" ? "selected" : ""} ${this.state.highlightedCompanyIndex === 0 ? "highlighted" : ""}`}
													onClick={() => this.setState({ selectedCompany: "", isCompanyDropdownOpen: false, companySearchInput: "" })}
													title="Tutte le aziende"
												>
													Tutte le aziende
												</div>
												{filteredCompanies
													.filter(company => company !== "")
													.map((company, index) => (
														<div
															key={index}
															id={`company-option-${index + 1}`}
															className={`company-option ${this.state.selectedCompany === company ? "selected" : ""} ${this.state.highlightedCompanyIndex === index + 1 ? "highlighted" : ""}`}
															onClick={() => this.setState({ selectedCompany: company, isCompanyDropdownOpen: false, companySearchInput: "" })}
															title={company}
														>
															{company}
														</div>
													))}
											</div>
										</div>
									)}
								</div>
							</div>

							<div className={"filter-panel-item"}>
								<div className={"filter-panel-label"}>Versione App</div>
								<div className={"version-inputs-row"}>
									<div className={"version-filter-item"}>
										<input
											className={"custom-version-input"}
											value={this.state.selectedVersionFrom}
											onChange={(e) => this.setState({ selectedVersionFrom: e.target.value })}
											placeholder="Da"
										/>
									</div>
									<div className={"version-filter-item"}>
										<input
											className={"custom-version-input"}
											value={this.state.selectedVersionTo}
											onChange={(e) => this.setState({ selectedVersionTo: e.target.value })}
											placeholder="A"
										/>
									</div>
								</div>
							</div>

							<div className={"filter-panel-item"}>
								<div className={"filter-panel-label"}>Piattaforma</div>
								<div className={"platform-filter-buttons"}>
									{(["android", "ios", "web"] as const).map(p => (
										<button
											key={p}
											className={`platform-filter-btn${this.state.selectedPlatform.includes(p) ? ' active' : ''}`}
											onClick={() => {
												const current = this.state.selectedPlatform;
												const next = current.includes(p) ? current.filter(x => x !== p) : [...current, p];
												this.setState({ selectedPlatform: next });
											}}
										>
											{p === "android" ? "Android" : p === "ios" ? "iOS" : "Web"}
										</button>
									))}
								</div>
							</div>

							<div className={"filter-panel-item"}>
								<div className={"filter-panel-label"}>Filtri Speciali</div>
								<div className={"potential-filter-item"}>
									<label className="toggle-label">Clienti Potenziali</label>
									<div
										className={`custom-toggle ${this.state.search.potential ? 'active' : ''}`}
										onClick={() => this.setState({ search: { ...this.state.search, potential: !this.state.search.potential, page: 1 } })}
									>
										<div className="toggle-handle"></div>
									</div>
								</div>
							</div>

						</div>

						<div className={"filter-panel-footer"}>
							<button
								className={"filter-reset-btn"}
								onClick={() => this.setState({
									selectedCompany: "",
									selectedVersionFrom: "",
									selectedVersionTo: "",
									selectedPlatform: [],
									search: { ...this.state.search, potential: false, page: 1 },
									inWaiting: true,
									isFilterPanelOpen: false,
								}, () => this.setSearch())}
							>
								Cancella tutto
							</button>
							<button
								className={"filter-apply-btn"}
								onClick={() => this.setState({ inWaiting: true, isFilterPanelOpen: false }, () => this.setSearch())}
							>
								Applica filtri
							</button>
						</div>
					</div>
				)}

				{/* ── Active filter chips ── */}
				{(!!this.state.selectedCompany || !!this.state.selectedVersionFrom || !!this.state.selectedVersionTo || this.state.selectedPlatform.length > 0 || this.state.search.potential) && (
					<div className={"active-filters-bar"}>
						<span className={"active-filters-label"}>Filtri attivi:</span>
						{!!this.state.selectedCompany && (
							<span className={"filter-chip"}>
								{this.state.selectedCompany}
								<button className={"filter-chip-remove"} onClick={() => this.setState({ selectedCompany: "", inWaiting: true }, () => this.setSearch())}>✕</button>
							</span>
						)}
						{(!!this.state.selectedVersionFrom || !!this.state.selectedVersionTo) && (
							<span className={"filter-chip"}>
								v.{this.state.selectedVersionFrom || '?'} → {this.state.selectedVersionTo || '?'}
								<button className={"filter-chip-remove"} onClick={() => this.setState({ selectedVersionFrom: "", selectedVersionTo: "", inWaiting: true }, () => this.setSearch())}>✕</button>
							</span>
						)}
						{this.state.selectedPlatform.map(p => (
							<span key={p} className={"filter-chip"}>
								{p === "android" ? "Android" : p === "ios" ? "iOS" : "Web"}
								<button className={"filter-chip-remove"} onClick={() => {
									const next = this.state.selectedPlatform.filter(x => x !== p);
									this.setState({ selectedPlatform: next, inWaiting: true }, () => this.setSearch());
								}}>✕</button>
							</span>
						))}
						{this.state.search.potential && (
							<span className={"filter-chip"}>
								Clienti Potenziali
								<button className={"filter-chip-remove"} onClick={() => this.setState({ search: { ...this.state.search, potential: false, page: 1 }, inWaiting: true }, () => this.setSearch())}>✕</button>
							</span>
						)}
					</div>
				)}


				{
					!!this.state.rawOrderPopup &&
					<div
						className={"raw-order-popup-backpan"}
						onClick={clickEvent => {
							this.setState({
								...this.state,
								rawOrderPopup: null
							});
						}}
					>
						<div
							className={"raw-order-popup"}
							onClick={clickEvent => {
								clickEvent.preventDefault();
								clickEvent.stopPropagation();
							}}
						>
							<div
								className={"raw-order-popup-header"}
								onClick={clickEvent => {
									clickEvent.preventDefault();
									clickEvent.stopPropagation();
									navigator.clipboard.writeText(beautify(this.state.rawOrderPopup));
								}}
							>
								<img src={'/imgs/stack_no_shadow.png'} className={"img-clipboard"} /> <code>Copia</code>
							</div>
							<pre>{beautify(this.state.rawOrderPopup)}</pre>
						</div>
					</div>
				}

				{

					(!!this.state.orders && isNotEmptyArray(this.state.orders)) && (

						<React.Fragment>

							{
								this.state.inWaiting &&
								<div className={"black-backpan blur-backpan"}>
									<WaitingOverPageComponent
										panelClassName={"single-circle-waiting over-layer"}
										title={"Ricerca..."}
									/>
								</div>
							}


							{/*<Paginator*/}
							{/*	magnitude={ this.state.magnitude }*/}
							{/*	currentPage={ this.state.currentPage }*/}
							{/*	onPageChange={ pageData => {*/}
							{/*		this.setState({*/}
							{/*			currentPage: pageData.currentPage,*/}
							{/*			// offset: pageData.offset,*/}
							{/*			inWaiting: true,*/}
							{/*		}, () => {*/}
							{/*			this.setSearch();*/}
							{/*		});*/}

							{/*	}}*/}
							{/*/>*/}


							<div
								className={'table-container'}
								onScroll={(e) => {
									const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
									if (scrollHeight - scrollTop - clientHeight < 150) {
										this.loadMoreOrders();
									}
								}}
							>
								<table>
									<thead>
										<tr>
											{
												// tutti i campi
												Object.keys(sortedOrders.reduce(getLastElementOr, []))

													// solo campi voluti
													.filter((orderField: string, orderFieldIndex: number) => Object.keys(orderFieldMap).includes(orderField))

													// ordina i campi
													.sort((a, b) => Object.keys(orderFieldMap).indexOf(a) - Object.keys(orderFieldMap).indexOf(b))

													// nome campi
													.map((orderFieldKey: string) => ({ key: orderFieldKey, label: orderFieldMap[orderFieldKey] }))

													// campi in HTML
													.map(({ key, label }) => (
														<th
															className={`${key === 'closed' ? 'status-column' : ''} col-${key} sortable-col${this.state.sortField === key ? ' sorted' : ''}`.trim()}
															onClick={() => {
																const newDirection = this.state.sortField === key && this.state.sortDirection === 'asc' ? 'desc' : 'asc';
																this.setState({ sortField: key, sortDirection: newDirection, openPannels: [] });
															}}
														>
															{label}
															{this.state.sortField === key && (
																<span className={"sort-indicator"}>{this.state.sortDirection === 'asc' ? ' ↑' : ' ↓'}</span>
															)}
														</th>
													))

											}
										</tr>
									</thead>
									<tbody>
										{
											sortedOrders
												.map((order: any, orderIndex: number) => [order, undefined])
												.flatMap((order: any, orderIndex: number) => {
													// showlog('riga ordine ', order);
													return order;
												})
												.flatMap((order: any, orderIndex: number) => (
													<tr
														onClick={(clickEvent: any) => {

															if (!!order) {
																// @ts-ignore
																if (this.state.openPannels.includes(orderIndex)) {
																	this.setState({
																		...this.state,
																		openPannels: this.state.openPannels.filter((op: any) => op !== orderIndex)
																	});
																} else {
																	this.setState({
																		...this.state,
																		openPannels: [...this.state.openPannels, orderIndex]
																	});
																}
															}



														}}
														className={`${((orderIndex % 4) === 0) ? 'even-row' : 'odd-row'}${!order ? ' detail-row' : ''}`}
													>
														{

															!!order
																? (
																	// tutti i campi
																	Object.keys(order)

																		// solo campi voluti
																		.filter((orderField: string, orderFieldIndex: number) => Object.keys(orderFieldMap).includes(orderField))

																		// ordina i campi
																		.sort((a, b) => Object.keys(orderFieldMap).indexOf(a) - Object.keys(orderFieldMap).indexOf(b))

																		// campi in HTML
																		.map((orderField: string, orderFieldIndex: number) => {
																			// showlog('order', order);
																			if (orderField === "closed") {
																				return (
																					<td className={"status-column"}>
																						{
																							!!order?.deleted
																								? (
																									<svg
																										className={"deleted-order-icon"}
																										width="16" height="16" viewBox="0 0 24 24"
																										fill="none" stroke="currentColor" strokeWidth="3"
																										strokeLinecap="round" strokeLinejoin="round"
																									>
																										<title>Ordine eliminato</title>
																										<line x1="18" y1="6" x2="6" y2="18"></line>
																										<line x1="6" y1="6" x2="18" y2="18"></line>
																									</svg>
																								)
																							: (
																								<img
																									src={!!order?.closed ? '/imgs/task_alt.svg' : '/imgs/schedule.svg'}
																									className={"new-customer-icon"}
																									alt="" />
																							)
																						}
																					</td>
																				)
																			}
																			if (orderField === "documentStatus") {
																				const statusMeta = getOrderStatusMeta(order[orderField]);
																				return (
																					<td className={"document-status-column"}>
																						{
																							!!statusMeta &&
																							<span
																								className={`document-status-chip document-status-chip--${statusMeta.colorKey}`}
																								title={statusMeta.label}
																							>
																								{statusMeta.shortLabel}
																							</span>
																						}
																					</td>
																				)
																			}
																			if (orderField === "itemsMagnitude") {
																				return (
																					<td className={"items-magnitude-column"}>{order[orderField]}</td>
																				)
																			}
																			if (orderField === "appVersion") {
																				return (
																					<td className={"app-version-column"}>{order[orderField]}</td>
																				)
																			}
																			if (orderField === "group") {
																				return (
																					<td className={"group-column"}>{order[orderField]}</td>
																				)
																			}
																			if (orderField === "numDocOriginale") {
																				return (
																					<td className={"num-doc-column"} title={order[orderField]}>{order[orderField]}</td>
																				)
																			}
																			if (orderField === "device") {
																				return (
																					<td className={"device-column"} title={order[orderField]}>{order[orderField]}</td>
																				)
																			}
																			if (orderField === "customer" && order?.tipoAnagrafica === 6) {
																				return (
																					<td>
																						<img src={'/imgs/ClienteAggiungi.svg'} className={"new-customer-icon"} alt="" />
																						{order[orderField]}
																					</td>
																				)
																			}
																			if (orderField === "operatorUsername") {
																				const roleType = order?.company?.roleType;
																				const roleLabel = roleType === 1 ? 'CA' : roleType === 2 ? 'RC' : null;
																				return (
																					<td className={"operator-username-column"} title={order[orderField]}>
																						{roleLabel && <span className={`agent-role-badge agent-role-badge--${roleLabel.toLowerCase()}`}>{roleLabel}</span>}
																						{order[orderField]}
																					</td>
																				)
																			}
																			if (orderField === "companyName") {
																				const isSpring = order?.company?.platform === "SPRING";
																				return (
																					<td className={"company-name-column"} title={order[orderField]}>
																						{isSpring && <span className={"spring-platform-icon"} title={"SPRING"}>S</span>}
																						{order[orderField]}
																					</td>
																				)
																			}
																			return (
																				<td>{order[orderField]}</td>
																			)
																		})
																)
																: (
																	// @ts-ignore
																	this.state.openPannels.includes(orderIndex - 1) &&
																	<td
																		colSpan={
																			Object.keys(sortedOrders.reduce(getLastElementOr, []))

																				// solo campi voluti
																				.filter((orderField: string, orderFieldIndex: number) => Object.keys(orderFieldMap).includes(orderField))

																				// ordina i campi
																				.sort((a, b) => Object.keys(orderFieldMap).indexOf(a) - Object.keys(orderFieldMap).indexOf(b))

																				// nome campi
																				.map((orderField: string, orderFieldIndex: number): string => orderFieldMap[orderField])

																				.length
																		}
																	>
																		{/*{this.renderer((orderIndex - 1) / 2)}*/}
																		<OrderComponent
																			order={sortedOrders[(orderIndex - 1) / 2]}
																			onDownloadOrderPress={(clickEvent) => {
																				clickEvent?.preventDefault();
																				clickEvent?.stopPropagation();
																				this.setState({
																					...this.state,
																					// rawOrderPopup: order
																					rawOrderPopup: sortedOrders[(orderIndex - 1) / 2]
																				});
																			}}
																			onCurlRequestPress={(clickEvent) => {
																				clickEvent?.preventDefault();
																				clickEvent?.stopPropagation();
																				showlog('sortedOrders[(orderIndex - 1) / 2]', sortedOrders[(orderIndex - 1) / 2]);
																				const currentOrder: any = sortedOrders[(orderIndex - 1) / 2]
																				if (!currentOrder || !currentOrder.payload || !currentOrder.agent) alert("impossibile recuperare ordine")
																				const cURL = prepareOrderCurl(currentOrder)
																				showlog('generated cURL: ', cURL);
																				navigator.clipboard.writeText(prepareOrderCurl(currentOrder));
																				alert("cURL copiato negli appunti!")
																			}}
																			onConnectorPress={(clickEvent) => {
																				try {
																					clickEvent?.preventDefault();
																					clickEvent?.stopPropagation();

																					// showlog('this.state.orders[(orderIndex - 1) / 2]', this.state.orders[(orderIndex - 1) / 2]);
																					// @ts-ignore
																					let connectorPayload = sortedOrders[(orderIndex - 1) / 2]?.connectorPayload || "";
																					// connectorPayload = JSON.parse(connectorPayload);
																					this.setState({
																						...this.state,
																						// rawOrderPopup: order
																						rawOrderPopup: connectorPayload
																					});
																				} catch (e) {
																					showlog("ERROR in connectorPress()", e);
																					alert("Impossibile recuperare il payload del connettore");
																				}
																			}}
																		/>
																	</td>
																)
														}
													</tr>
												))
										}
									</tbody>
								</table>
								{this.state.loadingMore && (
									<div className={"load-more-indicator"}>
										Caricamento...
									</div>
								)}
							</div>

						</React.Fragment>

					)
				}

				{
					!!this.state.errorPannel
						? (
							<AlertPanel
								content={this.state.errorPannel}
								onClose={() => {
									this.setState({
										...this.state,
										errorPannel: undefined
									})
								}}
							/>
						)
						: null
				}


			</React.Fragment >
		);

	}

	componentDidMount() {

		showlog("order componentDidMount");

		try {


			if (!!document.getElementById("searchText")) {

				// @ts-ignore
				fromEvent(document.getElementById("searchText"), 'keyup')
					.pipe(
						map((event: any) => event),
						debounceTime(750),
						distinct()
					)
					.subscribe((event) => {

						if (event.keyCode === 13) {
							if ((this.state.search.search !== event.target.value)) {
								showlog("search text subscription: " + event.target.value);

								this.setState({
									...this.state,
									search: {
										...this.state.search,
										search: event.target?.value || "",
										page: 1
									},
									inWaiting: true,
									coords: null,
									magnitude: 0,
								},
									() => {
										this.setSearch()
									}
								)

							}
						}


					})
					;

			}

			getLastVersion()
				.then(lastVersionData => {
					this.setState({
						...this.state,
						lastVersion: !!lastVersionData ? lastVersionData.reduce(getLastElementOr, "2.90.7").version : '',
						inWaiting: true
					},
						() => {
							this.setSearch();
						}
					);

				})
				.catch(e => {
					showlog("ERROR");
					showlog(e);
				})
				;

			getCompanies()
				.then(companiesData => {
					this.setState({
						...this.state,
						companies: companiesData?.data || []
					});
				})
				.catch(e => {
					showlog("ERROR FETCHING COMPANIES", e);
				});

		} catch (e) {
			showlog("ERROR");
			showlog(e);
		}


	}

}
